import {defineStore} from 'pinia';
import apiRequest from '@/util/api-request';
import { AxiosRequestConfig } from 'axios';
import { localStorageService } from '@/util/local_storage_service'

interface ILogin{
    pr_username: string | null;
    pr_password: string | null;
}

export const useAuthStore = defineStore('authStore', {
    // state
    state: (): ILogin => {
        return {
            pr_username: null,
            pr_password: null
        }
    },

    // getters
    getters: {
        prUsername: (state) => {
            return state.pr_username
        },
        prPassword: (state) => {
            return state.pr_password
        }
    },
    // actions
    actions: {
        async authLogin(username: string, password: string){
            const config: AxiosRequestConfig = {
                method: 'post',
                url: '/student/api/auth/login',
                data: {
                    username: username,
                    password: password
                },
            };
            const response = await apiRequest(config);
            return response
        },
        async authLogout(){
            const config: AxiosRequestConfig = {
                method: 'post',
                url: '/student/api/auth/logout',
            };
            const response = await apiRequest(config);
            // NFR-5116: delete study break data for logout user
            localStorageService.deleteStudyBreakData()
            return response
        },
        async fetchAuthStatus(){
            const config: AxiosRequestConfig = {
                method: 'get',
                url: '/student/api/auth/status',
                headers: {
                    'Content-Type': 'application/json',
                },
            };
            const response = await apiRequest(config);
            return response
        },
        // NFR-3909 pr環境でのログインの場合id,pwをstoreに保存する
        prLogin(pr_username: string, pr_password: string){
            this.pr_username = pr_username
            this.pr_password = pr_password
        }
    }
})